import React from "react";
import { Typography, Skeleton, Tooltip } from "@mui/material";
import { useGeocoding } from "../../hooks/useGeocoding";
import { useTranslate } from "@refinedev/core";

interface AddressCellProps {
  latitude?: number;
  longitude?: number;
  priority?: number;
}

export const AddressCell: React.FC<AddressCellProps> = ({
  latitude,
  longitude,
  priority = 0,
}) => {
  const translate = useTranslate();
  const { address, loading, error, isFromCache } = useGeocoding(
    latitude,
    longitude,
    { priority }
  );

  if (loading) {
    return <Skeleton variant="text" width={120} height={20} />;
  }

  if (error) {
    return (
      <Tooltip title={error}>
        <Typography variant="body2" color="error">
          {address}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={isFromCache ? translate("geocoding.fromCache") : translate("geocoding.fromApi")}>
      <Typography variant="body2">
        {address}
      </Typography>
    </Tooltip>
  );
};
